module.exports = __webpack_public_path__ + "static/media/Home_Background_Bookmakers_Desktop.6eafb556.png";